<template>
    <div id="main">

        <my-scroll scroll-state  ref="myScroll" :page="page" :on-pull="onPull" style="max-height:100vh; overflow-y: scroll !important;">
            <div slot="scrollList">
                <div class="expired_title">{{title}} ({{total}})</div>
                <div class="expired_dhl">{{companyName}}</div>
                <div class="expired_list" style="padding-bottom: 220px;">
                    <ul>
                        <li v-for="item in orderList" class="order_list" @click="orderDetail(item.articleId)">
                            <div class="list_title">Time stored: {{dateFormat(item.timeStored)}}</div>
                            <div class="list_value express-number">{{item.trakingNumber}}</div>
                            <div class="index-body-div tag-box">
                                <div class="Stored">
                                    {{$t(item.displayStatus)}}
                                </div>
                                <div class="Expired" @click.stop="detail(item)" v-if="item.overdueFlag && item.displayStatus === 'Stored'">
                                    {{$t('Exp')}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </my-scroll>
        <div class="empty" v-if="emptyOrder">
            Cannot find the order
        </div>
        <div class="expired_bt">
            <button class="details_bt_w" @click="$router.back()">
                {{$t('common.Back')}}
            </button>
            <button class="details_bt_b" @click="scan()">
                {{$t('common.ScanBarcode')}}
            </button>
        </div>
        <bottom></bottom>
    </div>
</template>

<script>
import bottom from '../Bottom.vue'
import MyScroll from '../MyScroll'

export default {
  name: 'EnterBarcode',
  data () {
    return {
      title: null,
      action: null,
      id: null,
      orderList: [],
      total: 0,
      companyName: '',
      status: null,
      emptyOrder: false,
      param: null,
      page: {
        total: 0
      }
    }
  },
  watch: {
    orderList (val) {
      if (val.length > 0) {
        this.emptyOrder = false
      } else {
        this.emptyOrder = true
      }
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  created () {
    const vue = this
    this.id = this.$route.query.id
    this.action = this.$route.query.action
    this.companyName = this.$route.query.name
    // 防止不传参数进入页面
    if (!this.id || !this.action) {
      alert('not found')
      this.$router.back()
    }
    // 获取行为
    this.action = this.$route.query.action
    let param = {logisticsId: vue.id, page: 0, size: 10}
    // let param = {page: 0, size: 10}
    if (this.action === 'merchantTakeExpress') {
      this.title = this.$t('expired.Returns')
      this.status = 'Returns'
      param.status = 'Returned'
    }
    if (this.action === 'collectExpiredExpress') {
      this.title = this.$t('expired.Expired')
      this.status = 'Expired'
      param.status = 'Expired'
    }
    this.param = param
    this.getData(param)
  },
  components: {bottom, MyScroll},
  methods: {
    getData (param) {
      const vue = this
      this.axios({
        method: 'get',
        url: this.api.queryOrders,
        params: param
      }).then(function (response) {
        // vue.orderList = response.data.content
        let tmp = response.data.content
        for (let i = 0; i < tmp.length; i++) {
          vue.orderList.push(tmp[i])
        }
        vue.total = response.data.totalElements
        vue.page.total = response.data.totalPages
      }).catch(function (error) {
        console.log(error)
      })
    },
    dateFormat (time) {
      if (!time) {
        return null
      }
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()] + this.$t('common.space')
      let d = time.getDate() + this.$t('common.dayFormat')
      let h = time.getHours()
      if (h.toString().length === 1) {
        h = '0' + h
      }
      let mm = time.getMinutes()
      if (mm.toString().length === 1) {
        mm = '0' + mm
      }
      let dateStr = m + d + ', ' + h + ':' + mm
      return dateStr
    },
    scan () {
      this.$router.push('/barcode?action=' + this.action + '&logisticsId=' + this.id)
    },
    orderDetail (ordersId) {
      this.$router.push('/order/details?order=' + ordersId + '&action=' + this.action + '&logisticsId=' + this.id)
    },
    onPull () { // 加载回调
      const vue = this
      if (this.param.page < this.page.total) {
        setTimeout(() => {
          this.param.page++
          // 加载完成
          console.log('加载完成')
          this.$refs.myScroll.setState(5)
          vue.getData(vue.param)
        }, 500)
      } else {
        console.log('没有数据了')
        // 没有数据了
        this.$refs.myScroll.setState(7)
      }
    }
  }
}
</script>

<style lang='less' scoped>
    .tag-box{
        top: 0.55rem;
        left: 0rem;
    }
    .express-number{
        margin-top: 0.1rem !important;
        top: -0.1rem !important;
        position: relative;
    }
    #main {
        position: relative;

        .expired_title {
            margin: 0.195rem 0.125rem;
            font-size: 0.35rem;
          font-family: Poppins-Bold;
            line-height: 0.415rem;
            // color: #1F8DC5;
            color: var(--primary-text-color)
        }

        .expired_dhl {
            margin-left: 0.125rem;
            margin-top: 0.1rem;
            color: #676767;
            font-size: 0.25rem;
            /*font-weight: bold;*/
            line-height: 0.3rem;
          font-family: Poppins-Bold;
        }

        .expired_list {
            margin-left: 0.125rem;

            .order_list {
                margin-top: 0.11rem;
                width: 3.5rem;
                height: 0.63rem;
                box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
                border-radius: 0.1rem;
                background: #FFFFFF;
                display: flex;
                flex-flow: column;
                position: relative;

                .list_title {
                    margin-top: 0.135rem;
                    margin-left: 0.215rem;
                    font-size: 0.125rem;
                    font-weight: 400;
                    font-family: 'Poppins-Regular';
                    line-height: 0.145rem;
                    color: #ACACAC;
                }

                .list_value {
                    margin-top: 0.015rem;
                    margin-left: 0.215rem;
                    color: #000000;
                    font-size: 0.15rem;
                    font-weight: 900;
                    line-height: 0.18rem;
                }

                .Expired {
                    position: absolute;
                    right: 0.75rem;
                    bottom: 0.205rem;
                    width: 0.35rem;
                    height: 0.19rem;
                    background: #fff;
                    color: rgba(255, 0, 0, 1);
                    padding: 0.015rem 0.045rem;
                    font-size: 0.125rem;
                    font-weight: 400;
                    line-height: 0.2rem;
                    border-radius: 0.1rem;
                    text-align: center;
                    font-family:'Poppins-Regular';
                    border: 0.005rem solid rgba(255, 0, 0, 1);
                }
                .Stored {
                    position: absolute;
                    right: 0.1rem;
                    bottom: 0.215rem;
                    width: 0.54rem;
                    height: 0.19rem;
                    background: rgba(31, 141, 197, 0.5);
                    color: rgba(255, 255, 255, 1);
                    padding: 0.015rem 0.045rem;
                    font-size: 0.125rem;
                    font-weight: 400;
                    line-height: 0.2rem;
                    border-radius: 0.1rem;
                    text-align: center;
                    font-family:'Poppins-Regular';
                }

                .Returns {
                    position: absolute;
                    right: 0.1rem;
                    bottom: 0.215rem;
                    width: 0.54rem;
                    height: 0.19rem;
                    background: rgba(178, 70, 154, 0.5);
                    color: #FFFFFF;
                    padding: 0.015rem 0.045rem;
                    font-size: 0.125rem;
                    font-weight: 400;
                    line-height: 0.19rem;
                    border-radius: 0.1rem;
                    text-align: center;
                    font-family: Rubik;
                }
            }
        }

        .expired_bt {
            position: fixed;
            width: 82%;
            // left: 9%;
            bottom: 0.4rem;
            z-index: 999;
            max-width: 400px;
            left: 50%;
            transform: translateX(-50%);

            .details_bt_w {
              width: 100%;
              height: 0.58rem;
              // background: rgba(255, 255, 255, 1);
              background: var(--primary-inverted-button-bg-color);
              box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
              opacity: 1;
              border-radius: 0.42rem;
              border: none;
              // color: rgba(5, 36, 96, 1);
              color: var(--primary-inverted-button-text-color);
              line-height: 0.235rem;
              font-size: 0.2rem;
              /*font-weight: bold;*/
              font-family: Poppins-Bold;
            }

            .details_bt_b {
              margin-top: 0.1rem;
              width: 100%;
              height: 0.58rem;
              // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
              // background: linear-gradient(to right, #191E96 , #00BEF5 );
              background: var(--primary-button-bg-color);
              box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
              border-radius: 0.42rem;
              border: none;
              // color: #ffffff;
              color: var(--primary-button-text-color);
              line-height: 0.235rem;
              font-size: 0.2rem;
              /*font-weight: bold;*/
              font-family: Poppins-Bold;
            }
        }

        .expired_more {
            width: 100%;
            height: 2.1rem;
            position: relative;

            .load_more {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                margin-top: 0.11rem;

                img {
                    width: 0.215rem;
                    height: 0.215rem;
                }

                span {
                    color: #ACACAC;
                    font-size: 0.15rem;
                    font-family:'Poppins-Regular';
                    font-weight:400;
                    line-height: 0.18rem;
                    margin-top: 0.045rem;
                    margin-left: 0.07rem;
                }
            }
        }

        .bottom {
            position: fixed;
            bottom: 0.06rem;
            max-width: 400px;
            max-width: 400px;
            left: 50%;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
        }

        .empty {
            width: 100%;
            color: rgba(172, 172, 172, 1);
            font-size: 0.15rem;
            text-align: center;
            position: absolute;
            top: 200%;
        }
    }
    .prohibit{
        overflow-y:unset !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Return/Expired.vue